module.exports = __webpack_public_path__ + "static/media/mihika_sanghvi.c2f538b1.jpg";